module.exports = __webpack_public_path__ + "static/media/Emer-bannerweb-5.d5f14cf3.png";